import React, { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import Loader from '@atoms/Loader'
import { PATHS } from '@constants/paths'
import { RequireAuth } from '@hoc/RequireAuth'

const ProgramPage = lazy(() => import('@pages/program/ProgramPage'))
const MyDiaryPage = lazy(() => import('@pages/myDiary/MyDiaryPage'))
const AppointmentSchedulerPage = lazy(
  () => import('@pages/appointmentScheduler/AppointmentScheduler'),
)
const AssociatedProductsPage = lazy(() => import('@pages/associatedProducts/AssociatedProductsPage'));
const AssociateProductPage = lazy(() => import('@pages/associateProduct/AssociateProductPage'));
const AssignAnotherCardPage = lazy(() => import('@pages/assignAnotherCard/AssignAnotherCardPage'));
const ProcessRemoveProductPage = lazy( () => import('@pages/processRemoveProduct/ProcessRemoveProductPage') );
const ProcessChangingProductsPage = lazy( () => import('@pages/processChangingProducts/ProcessChangingProductsPage') );
// LOAD PAGE ASYNCHRONOUSLY
const HomePage = lazy(() => import('@pages/home/HomePage'))
const ErrorPage = lazy(() => import('@pages/error/ErrorPage'))
const ProgramDetailsPage = lazy(
  () => import('@pages/programDetails/ProgramDetailsPage'),
)

const renderLoader = () => <Loader message="Nos estamos preparando para ti" />

const AppRoutes = () => {
  const isLocal = window.config.APP_ENV === 'local'
  const url = isLocal ? '' : window.config.BASE_URL;
  return (
    <Suspense fallback={renderLoader()}>
      <Routes>
        <Route
          path={`${url}/*`}
          element={
            <RequireAuth>
              <HomePage />
            </RequireAuth>
          }
        />
        <Route
          path={`${url}${PATHS.ROOT}`}
          element={
            <RequireAuth>
              <HomePage />
            </RequireAuth>
          }
        />
        <Route
          path={`${url}${PATHS.HOME}`}
          element={
            <RequireAuth>
              <HomePage />
            </RequireAuth>
          }
        />
        <Route path={`${url}${PATHS.ERROR}`} element={<ErrorPage />} />
        <Route
          path={PATHS.PROVISORY_PIP}
          Component={() => {
            window.location.href = 'https://metlifeorienta.cl/empresas'
            return null
          }}
        />
        <Route
          path={`${url}${PATHS.SPECIALTY_DETAIL}/:programId`}
          element={
            <RequireAuth>
              <ProgramDetailsPage />
            </RequireAuth>
          }
        />
        <Route
          path={`${url}${PATHS.SPECIALTIES}`}
          element={
            <RequireAuth>
              <ProgramPage />
            </RequireAuth>
          }
        />
        <Route
          path={`${url}${PATHS.SPECIALTY_DETAIL}`}
          element={
            <RequireAuth>
              <ProgramDetailsPage />
            </RequireAuth>
          }
        />
        <Route
          path={`${url}${PATHS.APPOINTMENT_SCHEDULER}`}
          element={
            <RequireAuth>
              <AppointmentSchedulerPage />
            </RequireAuth>
          }
        />
        <Route
          path={`${url}${PATHS.MYDIARY}`}
          element={
            <RequireAuth>
              <MyDiaryPage />
            </RequireAuth>
          }
        />
        <Route
          path={`${url}${PATHS.ASSOCIATEDPRODUCTS}/:idCard`}
          element={
            <RequireAuth>
              <AssociatedProductsPage />
            </RequireAuth>
          }
        />
        <Route
          path={`${url}${PATHS.ASSOCIATEPRODUCT}/:idCard`}
          element={
            <RequireAuth>
              <AssociateProductPage />
            </RequireAuth>
          }
        />
        <Route
          path={`${url}${PATHS.ASSIGN_ANOTHER_CARD}/:idCard`}
          element={
            <RequireAuth>
              <AssignAnotherCardPage />
            </RequireAuth>
          }
        />
        {/* ADD PAGE ROUTE */}
      <Route 
          path={ `${url}${PATHS.PROCESS_CHANGING_PRODUCTS}/:idCard` }
          element={
            <RequireAuth>
              <ProcessChangingProductsPage/>
            </RequireAuth>
          }
      />

      <Route 
          path={ PATHS.PROCESS_REMOVE_PRODUCT }
          element={
            <RequireAuth>
              <ProcessRemoveProductPage/>
            </RequireAuth>
          }
      />

      </Routes>
    </Suspense>
  )
}

export default AppRoutes
